module.exports = __webpack_public_path__ + "img/61ne.e8e97083.svg";